import { CommandItem } from '@/code/frontend/components/ui/command';
import type { PageItem } from '../types';

interface CmdKPageItemProps {
  page: PageItem;
  onSelect: (href: string) => void;
}

/**
 * Renders a single page navigation item in the command palette.
 */
export function CmdKPageItem({ page, onSelect }: CmdKPageItemProps) {
  const Icon = page.icon;

  return (
    <CommandItem
      key={page.href}
      value={page.href}
      onSelect={() => onSelect(page.href)}
      className="flex items-center gap-3"
    >
      <Icon className="h-4 w-4 text-muted-foreground" />
      <span>{page.label}</span>
    </CommandItem>
  );
}
